<div class="row main-panel pl-2 pr-2" *ngIf="menuCategories && (selectedStoreStatus$ | async) === 'LOADED'">
  <!-- Navigation -->
  <div class="top-smooth" [ngClass]="isCategoryAction ? 'category-action category-nav' : 'category-nav'"
    id="category-nav" role="navigation" [style.top.px]="contentHeaderHeight + safeAreaHeight + searchBarTopHidden">
    <div id="scrollable-panel" class="category-nav-content" [style.top.px]="contentHeaderHeight"
      [ngClass]="isAdminOrderCaptureUpdate && !isMobileApp ? 'category-nav-content-admin' : 'category-nav-content-cust'">
      <ul class="nav nav-tabs category-nav-ul">
        <li (click)="onSelectCategory(catItem.categoryId)" *ngFor="let catItem of menuCategories;" role="presentation"
          class="category-nav-li text-unselectable" id="tab{{catItem.categoryId}}" role="menuitem"
          [class.active]="selectedCat === catItem.categoryId">
          <div>
            <div class="category-image-view" id="category-image-view" [ngClass]="{'no-image': !catItem.standardImage}"
              [style.background-image]="getBackgroundImage(catItem.standardImage)">
            </div>
          </div>
          <div class="category-nav-name font-size-primary py-2 px-2">
            {{catItem.name}}
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Catalog Panel -->
  <div class="catalog-panel" *ngIf="menuCategories">
    <div class="catalog-content" [ngStyle]="isMobileApp ? {'padding-bottom':'7vh'}:{}"
      [style.background-image]="getBackgroundImage( (selectedStore$ | async)?.settings?.IMAGE_BACKGROUND )">
      <div *ngFor="let catItem of getFilteredCategories();" id="category{{catItem.categoryId}}" class="category-tab"
        [ngClass]="{ 
          'collapsable': (selectedStore$ | async)?.settings?.CATALOG_CATEGORIES_COLLAPSE, 
          'searchEpanded': categorySearch 
        }">
        <div class="category-header w-100 d-flex  font-weight-bold justify-content-between"
          [style.background]="(getBackgroundImage( (selectedStore$ | async)?.settings?.IMAGE_BACKGROUND )) ? '' : '#F2F0EE'"
          (click)="currentCartStatus === 'LOADED' && onSelectCategory(catItem.categoryId, 'toggle')" [ngClass]="{
            'theme-light-cat-name-bg-none': getBackgroundImage((selectedStore$ | async)?.settings?.IMAGE_BACKGROUND),
            'theme-light-cat-name-bg-light-grey': !getBackgroundImage((selectedStore$ | async)?.settings?.IMAGE_BACKGROUND)
          }">
          <div class="catWidth mr-2 px-2 px-md-3 py-2 py-md-3" [ngClass]="{'cattitle-revser': isCategoryAction}">
            {{ catItem.name }}
            <div class="font-size-primary font-weight-normal mt-2" *ngIf="catItem.shortDescription">
              {{catItem.shortDescription}}
            </div>
          </div>
          <div class="category-header-right-panel">
            <div class="category-image m-2" [ngClass]="{'d-none':!catItem.standardImage}"
              [style.background-image]="getBackgroundImage(catItem.standardImage)">
            </div>
            <div [ngClass]="{'d-none': !(selectedStore$ | async)?.settings?.CATALOG_CATEGORIES_COLLAPSE }">
              <i class="fa m-auto collapse-icon" [ngClass]="{
      'collapse-icon-image': getBackgroundImage(catItem.standardImage),
      'collapse-icon-no-image': !getBackgroundImage(catItem.standardImage),
      'fa-chevron-down': isCategoryExpanded(catItem.categoryId),
      'fa-chevron-right': !isCategoryExpanded(catItem.categoryId),
      'icon-revser': isCategoryAction
   }">
              </i>
            </div>
          </div>
        </div>

        <div class="catalog-grid mb-4">
          <div class="catalog-item" *ngFor="let menuItem of getOffers(catItem);"
            [ngClass]="{'pointer': showPlusButton(menuItem) && menuItem.inStock, 'overlay': !menuItem.inStock}"
            (click)="currentCartStatus === 'LOADED' && viewProductDetails(menuItem.offerId, catItem.categoryId, menuItem.inStock, menuItem.isExpandable, menuItem.isOrderable, basketEnabled)">
            <div class="offer-image" [style.background-image]="getBackgroundImage(menuItem.standardImage)"
              (click)="onOfferImageClick($event, menuItem)">
              <div class="content  p-1">
                <app-offer-actions [offer]="menuItem" [cartItems]="getCartItems(menuItem)"
                  [currentCartStatus]="currentCartStatus" [itemAddedToCart]="itemAddedToCart"
                  [decreaseItemQty]="decreaseItemQty" [basketEnabled]="basketEnabled"
                  [orderingEnabled]="orderingEnabled">
                </app-offer-actions>
              </div>
            </div>
            <div class="offer-details p-2">
              <span class="calories-info" *ngIf="isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')">
                <img src="/assets/img/offer-characteristics/Customer/fire.png" alt="">
                {{isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')}} kcal
              </span>
              <div class="offer-name font-weight-bold theme-color-subtitle-2">{{menuItem.name}}</div>
              <div *ngIf="menuItem.shortDescription" class="description font-size-primary text-break">
                {{ menuItem.shortDescription }}
              </div>
              <app-offer-price [menuItem]="menuItem" [locale]="selectedStoreLocale" [currency]="selectedStoreCurrency"
                [currencySymbol]="selectedStoreCurrencySymbol">
              </app-offer-price>
              <app-allergens [attributes]="menuItem.attributeDtos"
                [isAdminOrderCaptureUpdate]="isAdminOrderCaptureUpdate"></app-allergens>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <app-view-order-button [customerFooterHeight]="customerFooterHeight" [selectedCatalog]="selectedCatalog"
        [showPayOnlineButton]="showPayOnlineButton" [cartItemsTotalValue]="cartItemsTotalValue"
        [totalQuantity]="totalQuantity" [selectedStoreLocale]="selectedStoreLocale"
        [selectedStoreCurrency]="selectedStoreCurrency" [selectedStoreCurrencySymbol]="selectedStoreCurrencySymbol"
        [acceptTermVisible]="acceptTermVisible" [showAlways]="true" [cartItems]="cartItems"
        (viewOrder)="onViewOrder($event)" (payOnline)="onPayOnline()">
      </app-view-order-button>
    </div>

  </div>
</div>